import React from 'react';
import { Link } from 'react-router-dom';
import { FiAlertCircle } from 'react-icons/fi';
import './DashboardTemplates.css';

export const formatPoints = (value) => {
  const num = Number(value ?? 0);
  return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

export const DashboardShell = ({ title, subtitle, children, data }) => {
  const approverLink = data?.can_approve
    ? `/approver-dashboard?company_id=${data.company.id}`
    : null;

  return (
    <div className="cd-dashboard">
      <header className="cd-header">
        <div>
          <h1>{title}</h1>
          {subtitle && <p className="cd-subtitle">{subtitle}</p>}
        </div>
        {data?.role && (
          <span className="cd-role-badge">{data.role}</span>
        )}
      </header>

      {data?.can_approve && data.pending_approvals_count > 0 && (
        <Link to={approverLink} className="cd-approver-banner">
          <FiAlertCircle />
          <span>
            {data.pending_approvals_count} pending approval
            {data.pending_approvals_count === 1 ? '' : 's'} — review now
          </span>
        </Link>
      )}

      {children}
    </div>
  );
};

export const StatCards = ({ items }) => (
  <div className="cd-stat-grid">
    {items.map((item) => (
      <div className="cd-stat-card" key={item.label}>
        <span className="cd-stat-label">{item.label}</span>
        <span className="cd-stat-value">{item.value}</span>
        {item.hint && <span className="cd-stat-hint">{item.hint}</span>}
      </div>
    ))}
  </div>
);

export const SimpleBarChart = ({ data, valueKey = 'amount' }) => {
  const max = Math.max(...data.map((d) => d[valueKey] ?? 0), 1);

  return (
    <div className="cd-bar-chart">
      {data.map((item) => (
        <div className="cd-bar-item" key={item.label}>
          <div
            className="cd-bar-fill"
            style={{ height: `${Math.round(((item[valueKey] ?? 0) / max) * 100)}%` }}
            title={`${item.label}: ${formatPoints(item[valueKey])}`}
          />
          <span className="cd-bar-label">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export const downlineColumns = [
  { key: 'name', label: 'Name' },
  { key: 'role', label: 'Role', render: (row) => row.role ?? '—' },
  {
    key: 'is_direct',
    label: 'Relation',
    render: (row) => (row.is_direct ? 'Direct' : 'In your network'),
  },
  { key: 'sales_count', label: 'Sales (all-time)' },
  { key: 'sales_count_this_month', label: 'Sales this month' },
];

export const DataTable = ({ title, columns, rows, emptyMessage = 'No data yet.' }) => (
  <section className="cd-panel">
    {title && <h2 className="cd-panel-title">{title}</h2>}
    {rows?.length ? (
      <div className="cd-table-wrap">
        <table className="cd-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={row.id ?? idx}>
                {columns.map((col) => (
                  <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="cd-empty">{emptyMessage}</p>
    )}
  </section>
);

export const WalletCta = () => (
  <div className="cd-wallet-cta">
    <Link to="/wallet" className="cd-btn-primary">Open Wallet</Link>
  </div>
);
